// Read-model only — rows are written by the trigger in migrations/0109_record_history.sql,
// never by app code, so there's no insert schema.
import { pgTable, bigserial, text, jsonb, timestamp, index } from "drizzle-orm/pg-core";

export const recordHistory = pgTable(
  "record_history",
  {
    id: bigserial("id", { mode: "number" }).primaryKey(),
    tableName: text("table_name").notNull(),
    recordId: text("record_id").notNull(),
    operation: text("operation").notNull(), // insert | update | delete
    oldRow: jsonb("old_row"),
    newRow: jsonb("new_row"),
    changedByUserId: text("changed_by_user_id"),
    changedByRole: text("changed_by_role"),
    requestId: text("request_id"),
    changedAt: timestamp("changed_at", { withTimezone: true }).defaultNow().notNull(),
  },
  (t) => ({
    lookupIndex: index("idx_record_history_lookup").on(t.tableName, t.recordId, t.changedAt),
  }),
);

export type RecordHistory = typeof recordHistory.$inferSelect;
